module.exports = "/static/assets/a1db95304722ee4bb6b7df7c49b563fc.png";